<template lang="pug">
.blog-listing
	Loader(v-if="!pageLoaded")
	.blog-listing__inner(v-else)
		.blog-listing__list
			BlogCard(v-for="blog in blogs", :key="blog.blogDetailPageID", :blog="blog", :isCategoryPage="isCategoryPage")
		Pagination(
			:page="page",
			:total="totalBlogs",
			:blogsPerPage="blogsPerPage",
			@navigate="handleNavigate"
		)
</template>

<script>
import Loader from "../locationsListing/components/Loader";
import BlogCard from "./components/BlogCard";
import Pagination from "./components/Pagination";

export default {
	name: "BlogListingApp",
	components: {
		Loader,
		BlogCard,
		Pagination,
	},
	data() {
		return {
			pageLoaded: false,
			page: 1,
			blogs: null,
			totalBlogs: null,
			blogsPerPage: null,
			url: null,
			isCategoryPage: false,
			category: null,
			tag: null,
		};
	},
	computed: {},
	methods: {
		async getBlogData(page) {
			let displayVal = this.page === 1 ? "" : "none";
			const featuredArticle = document.querySelector(".hero--blog-featured") || false;
			if (featuredArticle) featuredArticle.style.display = displayVal;
			this.pageLoaded = false;
			let queryString = "";
			if (this.category) queryString += "/?category=" + this.category;
			if (this.tag) queryString += "/?tag=" + this.tag;
			let url;
			// Below used to prevent breaking on FE/design while still keeping format correct for BE api endpoint
			if (this.url.host.includes("localhost:") || this.url.host.includes("192.168.4.31") || this.url.host.includes(".design.bluemod.us")) {
				if (this.category || this.tag) url = this.$root.apiEndpoint + queryString + page
				else url = this.$root.apiEndpoint + queryString
			} else {
				url = this.$root.apiEndpoint + page + queryString
			}
			await fetch(url)
				.then((res) => res.json())
				.then((data) => {
					// console.log(data);  // for testing purposes
					this.pageLoaded = true;
					this.blogs = data.articles;
					if (!this.totalBlogs && !this.blogsPerPage) {
						this.totalBlogs = data.total;
						this.blogsPerPage = data.articles.length;
					}
				});
		},
		handleNavigate(newPage) {
			this.pageLoaded = false;
			this.url.searchParams.set("page", newPage);
			window.history.replaceState({}, "", this.url.href);
			this.page = parseInt(newPage);
			window.scroll({
				top: this.$el.getBoundingClientRect().top + window.scrollY,
				left: 0,
				behavior: "smooth"
			});
			setTimeout(() => {
				this.getBlogData(parseInt(newPage));
			}, 750);
		}
	},
	async created() {
	},
	async mounted() {
		this.isCategoryPage = !!this.$root.categories;
		this.url = new URL(window.location);
		if (this.url.searchParams.has("page")) {
			if (isNaN(this.url.searchParams.get("page"))) {
				this.url.searchParams.delete("page");
				window.history.replaceState({}, "", this.url.href);
			} else {
				this.page = parseInt(this.url.searchParams.get("page"));
			}
		}
		if (this.isCategoryPage) {
			if (this.url.searchParams.has("category")) {
				this.category = this.url.searchParams.get("category");
			}
			if (this.url.searchParams.has("tag")) {
				this.tag = this.url.searchParams.get("tag");
			}
		}
		await this.getBlogData(this.page);
	},
};
</script>


<style scoped lang="scss">
.blog-listing {
	margin-top: 0;
}
</style>